export enum TRACKED_EVENTS {
  signedIn = 'user_signed_in',
  signUp = 'user_signed_up',
  programsSearch = 'program_searched',
  programCreated = 'program_created',
  programDeleted = 'program_deleted',
  programModified = 'program_modified',
  programViewed = 'program_viewed',
  programImpression = 'program_impression',
  programShared = 'program_shared',
  programApplicationSubmitted = 'program_application_submitted',
  programApplicationViewed = 'program_application_viewed',
  programApplicationDeleted = 'program_application_deleted',
  programApplicationCreated = 'program_application_created',
  programApplyNowClicked = 'program_apply_now_clicked',
  institutesSearch = 'institutes_searched',
  toursSearch = 'tour_searched',
  tourImpression = 'tour_impression',
  tourViewed = 'tour_viewed',
  tourBookClicked = 'tour_book_clicked',
}

export enum TRACKED_PAGES {
  home = 'Home',
  dashboard = 'Dashboard',
  applications = 'Applications',
  applicationView = 'Application View',
  applicationForm = 'Application Edit',
  applicationCreate = 'Application Create',
  inovices = 'Invoices',
  inoviceView = 'Inovice View',
  wallet = 'Wallet',
  programSearch = 'Program Search',
  programDetail = 'Program Detail',
  programEdit = 'Program Edit',
  solutionStudents = 'Solution Students',
  solutionRecruiters = 'Solution Recruiters',
  solutionInstitutes = 'Solution Institutes',
  organisationSearch = 'Institute Search',
  organisationDetail = 'Institute Detail',
  tourSearch = 'Tour Search',
  tourDetail = 'Tour Detail',
  tourCheckout = 'Tour Checkout',
  tourBooking = 'Tour Booking',
  tourBookings = 'Tour Bookings',
  profile = 'Profile',
  referrals = 'Referrals',
  currency = 'Currency',
  language = 'Language',
  addons = 'Addons',
  visaHome = 'Visa Home',
  visaInfo = 'Visa Info',
  visaDetail = 'Visa Detail',
  visaCheckout = 'Visa Checkout',
  visaApplications = 'Visa Applications',
  agencies = 'Agencies',
  institutes = 'Institutes',
  organisationsDashboard = 'Organisations Dashboard',
  cards = 'Cards',
  banks = 'Banks',
  branches = 'Branches',
  intakes = 'Intakes',
  notifications = 'Notifications',
  preferences = 'Preferences',
  users = 'Users',
  emailTemplates = 'Email Templates',
  quoteDetail = 'Quote Detail',
  quotes = 'quotes',
  payables = 'payables',
  complianceDetail = 'Compliance Detail',
  complianceEdit = 'Compliance Edit',
  complianceList = 'Compliance List',
}
